import { useSelector } from "react-redux";
import { Alert, Autocomplete, Box, Button, CircularProgress, Stack, TextField } from "@mui/material";
import { useEffect, useState } from "react";
const AttributeSelectionStep = ({ setSelectedAttributes, onBack, onComplete, loading, selectedPlace, accountMarketpleacesName ,categoryAttribute}) => {
    //const categoryVariant = useSelector((state) => state?.outWardCategoryAttribute || []);
    const [outWardCategoryAttribute, setOutWardCategoryAttribute] = useState([]);
    useEffect(() => {
        if (categoryAttribute?.length > 0) {

            const filteredAttributes = categoryAttribute?.map(item => item);
            setOutWardCategoryAttribute(filteredAttributes);
        }
        else {

            <Alert severity="warning" sx={{ width: '100%', mb: 2 }}>
                                    Seçilen pazaryerinde ürününüze ait kategori eşleşmiyor.
                                    Kategori sayfasından eşleştirme yapınız.
                                </Alert>
        }


    }, [categoryAttribute]);
    console.log("categoryAttribute", categoryAttribute);
    const updatedAttributes = outWardCategoryAttribute?.map((item) => ({
        ...item,
        attribute: { ...item.attribute, varianter: item.varianter },
    }));
    const handleSelect = (attribute, value) => {
        if (value) {
            if (typeof value === 'object') {
                setSelectedAttributes((prev) => [
                    ...prev.filter((item) => item.attribute.id !== attribute.id),
                    { attribute, value },
                ]);
            }
            else {
                setSelectedAttributes((prev) => [
                    ...prev.filter((item) => item.attribute.id !== attribute.id),
                    { attribute, value },
                ]);
            }
        } else {
            setSelectedAttributes((prev) =>
                prev.filter((item) => item.attribute.id !== attribute.id)
            );
        }
    };
    return (
        <Box>



            {

                loading ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="100vh"
                        width="100%"
                    >
                        <CircularProgress />
                    </Box>
                ) :


                    selectedPlace?.type == "ecommerce" || selectedPlace?.name == "Pttavm" ?
                        <Alert severity="warning" sx={{ width: '100%', mb: 2 }}>
                            Seçilen pazaryeri için özellik seçimi gerekli değil
                        </Alert>

                        :
                        !accountMarketpleacesName?.includes(selectedPlace.name) ? (
                            <Alert severity="warning" sx={{ width: '100%', mb: 2 }}>
                                Seçilen pazaryeri için ayarlar eksik. Lütfen{" "}
                                <a
                                    href="/Profile"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                        color: "blue",
                                    }}
                                >
                                    profil
                                </a>{" "}
                                alanından gerekli bilgileri doldurunuz.
                            </Alert>
                        ) :


                            categoryAttribute?.length > 0 ? (
                                <Stack spacing={2}>


                                    {updatedAttributes
                                        ?.sort((a, b) => b.required - a.required)
                                        ?.map(
                                            (item) =>
                                                item?.attributeValues?.length > 0 && (
                                                    <Autocomplete
                                                        key={item?.attribute?.id}
                                                        disablePortal
                                                        options={item?.attributeValues}
                                                        getOptionLabel={(option) => option.name || ''}
                                                        onChange={(event, value) => handleSelect(item.attribute, value)}
                                                           filterOptions={(options, { inputValue }) => {
                                                            const filteredOptions = options.filter(option =>
                                                                option.name.toLowerCase().includes(inputValue.toLowerCase())
                                                            );
                                                            return filteredOptions.slice(0, 20);
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label={
                                                                    item.required
                                                                        ? `${item?.attribute?.name} (${item?.attribute?.varianter ? 'Varianter' : ''})`
                                                                        : item?.attribute?.name
                                                                }
                                                                required={item.required}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        color: item.required ? 'red' : 'inherit',
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                )
                                        )}

                                    {updatedAttributes.map((item) => (
                                        item?.attributeValues?.length === 0 && (
                                            <TextField
                                                key={item?.attribute?.name}
                                                id="outlined-basic"
                                                label={
                                                    item.required
                                                        ? `${item?.attribute?.name} * (${item?.attribute?.varianter ? 'Varianter' : ''})`
                                                        : item?.attribute?.name
                                                }
                                                variant="outlined"
                                                required={item.required}
                                                sx={{
                                                    width: '100%',
                                                }}
                                                onChange={(e) => handleSelect(item.attribute, e.target.value)}
                                            />
                                        )
                                    ))}

                                </Stack>

                            ) : (
                                <Alert severity="warning" sx={{ width: '100%', mb: 2 }}>
                                    Seçilen pazaryerinde ürününüze ait kategori eşleşmiyor.
                                    Kategori sayfasından eşleştirme yapınız.
                                </Alert>
                            )

            }

            <Box display="flex" justifyContent="space-between" sx={{ mt: 2 }}>
                {/* Soldaki Geri butonu */}
                <Button
                    variant="outlined"
                    onClick={onBack}
                    size="large"
                    sx={{ px: 4, borderRadius: 2 }}
                >
                    Geri
                </Button>

                {/* Sağdaki Bitir ve Ürünleri gönder butonları yan yana */}
                <Box display="flex" gap={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onComplete}
                        size="large"
                        sx={{ px: 4, borderRadius: 2 }}
                    >
                        Devam
                    </Button>
                </Box>
            </Box>

        </Box>
    );
};
export default AttributeSelectionStep;